// ArenaDisplay.js

// import React...
import React, { Component } from 'react';

// ... and fullcalendar-reactwrapper.
import FullCalendar from 'fullcalendar-reactwrapper';
import ArenaDisplayTheme from '../assets/style/arenaDisplay.css'
import moment from 'moment';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faSignal, faHourglassHalf } from '@fortawesome/free-solid-svg-icons'


class Calendar extends Component {
    constructor(props) {
        super(props);
        this.hideNav = true;
        this.calendarRef = React.createRef();
        this.state = {
        fetchStatus: faHourglassHalf,
        events: []
      };
      
    };

    eventRender(event, element, view) {
        if (view.type === 'arenaDisplay') {
            var toInject = [];
            if (event.home_room) {toInject.push('Home: ' + event.home_room)} else {toInject.push('<nbsp/>')};
            if (event.away_room) {toInject.push('Away: ' + event.away_room)} else {toInject.push('<nbsp/>')};
 //           toInject.push(event.end);
            for (var i = 0; i < toInject.length; i++) {	               
                element.append('<td>'+toInject[i]+'</td>');	     
            }          
        }
    };

    fectchEvents() {
    var date = new moment().format('YYYY-MM-DD');
    var eventUrl = 'https://beiseker.bookice.ca/api/v0/calendar?start=' + date + '&end=' + date;
    fetch(eventUrl).then(response => {
            if (!response.ok) {
                console.log(response.statusText);
                return Promise.reject(response.statusText);
            }
            console.log(response.statusText);
            return response.json();
            })
            .catch(error => {
                console.log(error);
                this.state.fetchStatus = faExclamationTriangle;
            })
            .then(json => {
                if (json) {
                    this.state.fetchStatus = faSignal;
                    this.state.events = json;
                    this.calendarRef.current.updater.enqueueForceUpdate(this);
                    return true;
                } else {
                    this.state.fetchStatus = faExclamationTriangle;
                    return false;
                }
            });
        
        }

    componentDidMount() {
        this.fectchEvents();
        setInterval(() => {
            //refresh calendar every 30 mins
            this.fectchEvents();
        }, 1800000)
    }

    handleEventClick(event) {
         this.props.history.push('/event/' + event.guid);
    }

    render() {
        return (
          <div id="example-component">
            <div id="status">
                <FontAwesomeIcon icon={this.state.fetchStatus}/>
            </div>
            <div id="schedule">
                <FullCalendar
                    class = 'arena-display'
                        id = "Arena-Calendar-View"
                    header = {{
                        left: '<FontAwesomeIcon icon={this.state.fetchStatus}/>',
                    center: 'title',
                        right: ''
                    }}
                    views = {{
                        arenaDisplay: {
                        type: 'list',
                        duration: { days: 1 },
                        buttonText: 'Arena Display'
                        }
                    }}
                    defaultView = 'arenaDisplay'
                    contentHeight = 'auto'
                    //eventSources = {this.state.eventSources}
                    events = {this.state.events}
                    eventRender = {this.eventRender.bind(this)}
                    eventClick = {this.handleEventClick.bind(this)}
                    theme={ArenaDisplayTheme}
                    ref={this.calendarRef}
                />
            </div>
          </div>
        );
      }
}

export default Calendar;


// WEBPACK FOOTER //
// ./src/components/ArenaDisplay.js